import { Box, Grid, Typography, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../theme/colors";
import { Icon } from "../../../components/base";
import { NoDataCard } from "../../../components/parts";
import { LabelBarChart } from "../../../components/charts";
import { currencyFormatter, nKilowattFormatter } from "../../../services";
import totalElectricityImg from "../../../assets/images/icons/total-electricity.svg";

const useStyles = makeStyles(() => ({
  chartBox: {
    height: 270,
    borderRadius: 8,
    marginTop: 20,
  },
  title: {
    padding: "10px 0 0 20px",
  },
}));

export const ElectricityConsumptionPart = ({
  electricityCostsChartData,
  electricityConsumptionChartData,
  bars,
}) => {
  const classes = useStyles();

  return (
    <Box style={{ backgroundColor: COLORS.darks[0][3], borderRadius: 8, marginBottom: 30 }}>
      <Grid container>
        <Grid item xs={4} container justifyContent="center" alignItems="center" direction="column">
          <Icon src={totalElectricityImg} />
          <Typography variant="h2" style={{ fontWeight: 500, marginTop: 20 }}>
            Electricity Consumption
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="h4" className={classes.title}>
            Total electricity costs
          </Typography>
          <Box className={classes.chartBox}>
            {electricityCostsChartData.length ? (
              <LabelBarChart
                top={50}
                left={5}
                right={35}
                height={270}
                chartData={electricityCostsChartData}
                bars={bars}
                barSize={50}
                yTickFormatter={currencyFormatter}
              />
            ) : (
              <NoDataCard withShaDowBox={false} gridStyle={{ height: 160 }} />
            )}
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="h4" className={classes.title}>
            Total est. electricity consumption
          </Typography>
          <Box className={classes.chartBox}>
            {electricityConsumptionChartData.length ? (
              <LabelBarChart
                top={50}
                left={5}
                right={35}
                height={270}
                chartData={electricityConsumptionChartData}
                bars={bars}
                barSize={50}
                yTickFormatter={nKilowattFormatter}
              />
            ) : (
              <NoDataCard withShaDowBox={false} gridStyle={{ height: 160 }} />
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
